import { render, staticRenderFns } from "./Distributors.vue?vue&type=template&id=0aabebce&"
import script from "./Distributors.vue?vue&type=script&lang=js&"
export * from "./Distributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports